import http from './http'
const api={} 
api.reqLogin=(params) => http.post('/authentication-server/business/loginByPhoneCode', params); //验证码登录
api.reqBurialPoint=(params) => http.post('/system-server/event-tracking/add', params) //新增埋点数据
api.reqProByAccount=(params) => http.get('/iotmonitor-server/waterDispenser/listProjectByAccountCode', params) //根据设备账户获取项目列表

api.reqGetMonitorNum=(params) => http.get('/iotmonitor-server/monitor/overview/project/data/getProjectMonitorNum', params); //项目监测次数
api.reqGetWaterUsePro=(params) => http.get('/iotmonitor-server/monitor/overview/project/data/listWaterUserInfoByProject', params); //项目用水趋势
api.reqGetRecentList=(params) => http.get('/iotmonitor-server/monitor/overview/project/data/listNearFutureOrderServiceByProject', params); //项目服务
api.reqGetOffOnlinePro=(params) => http.get('/iotmonitor-server/monitor/overview/project/data/listOfflineServiceByProject', params); //线下服务内容
api.reqGetProBase=(params) => http.get('/iotmonitor-server/monitor/overview/project/data/getProjectBaseInfo', params); //项目信息 （净水流量 服务总人数 设备总数 实时净水TDS均值 人均饮水量）
api.reqGetEquipList=(params) => http.get('/iotmonitor-server/monitor/overview/project/data/listEquipListByProjectCode', params); //饮水点
api.reqGetEquipBaseInfo=(params) => http.get('/iotmonitor-server/monitor/overview/equip/data/getEquipBaseInfo', params); //获取单个设备信息
api.reqGetMicroEquip=(params) => http.get('/iotmonitor-server/monitor/overview/equip/data/getMicroInfoByEquip', params); //设备一段时间内的微生物滋生趋势
api.reqGetFilterEquip=(params) => http.get('/iotmonitor-server/monitor/overview/equip/data/getFilterPercentByEquip', params); //设备一段时间内的微生物滋生趋势

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js